import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { ReporteData, Turno } from 'src/app/models';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { TipoVehiculoService } from 'src/app/services/tipo-vehiculo.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { getTurno } from 'src/app/utils';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-reporte-carril',
  templateUrl: './reporte-carril.component.html',
  styleUrls: ['./reporte-carril.component.scss']
})
export class ReporteCarrilComponent implements OnInit {
  loadingIndicator:boolean = false;
  ColumnMode = ColumnMode;
  colums = [{ name: 'CARRIL' },{ name: 'T01M' },{ name: 'T01A' }, { name: 'T01L01A'}, 
  { name: 'T02B' },{ name: 'T03B' },{ name: 'T04B' },{ name: 'T02C' },{ name: 'T03C' },
  { name: 'T04C' },{ name: 'T05C' }, { name: 'T06C' },{ name: 'T07C' },{ name: 'T08C' },{ name: 'T09C' },
  { name: 'EEC' },{ name: 'CANTIDAD'}, {name: 'SUBTOTAL'}];
  
  tipoVehiculos:any[] = [];
  rows:ReporteData;
  formBusqueda:FormGroup;
  turnos:any[] = [];
  carriles:any[] = [];
  turnoActual:Turno;
  totalCobrado:number = 0;
  turnosNames = {
    1: 'NOCTURNO',
    2: 'MATUTINO',
    3: 'VESPERTINO'
  }
  constructor(private reporteService:ReporteriaService,
              private formBuilder:FormBuilder,
              private ngxUiLoaderService:NgxUiLoaderService,
              private toastr:ToastrService,
              private store: Store<AppState>,
              private vehiculoService:TipoVehiculoService) { }

  ngOnInit(): void {
    this.turnoActual = getTurno(); // { id: 1: name: Matutino}
    this.createForm();
    this.getData();
  }

  createForm(){
    this.formBusqueda = this.formBuilder.group({
      fecha: [''],
      turno: [''],
      carriles: ['']
    });
    this.formBusqueda.get('turno').setValue(this.turnoActual.id);//selected turno actual
    this.formBusqueda.get('fecha').setValue(moment().format('YYYY-MM-DD'));//fecha actual
  }

  getCasetaUser(){
    let casetaTroncal;
    this.store.select(selectUser).subscribe( usuario => { // Obtener info del usuario
      casetaTroncal = usuario.caseta_usuario.find(caseta => caseta.tipo === 1);// Obtener caseta troncal
    });
    return casetaTroncal;
  }

  async getData(){
    let caseta = this.getCasetaUser();
    this.vehiculoService.getClasificacionTarifa() //get all clasificaciones vehiculo
    .subscribe(clasificaciones => { //[ {clasificacion: T01, tarifa : 200.00 } ]
      this.tipoVehiculos = clasificaciones;
    });

    await Promise.all([this.reporteService.getTurnos(), this.reporteService.getCarriles(caseta.id)]).
    then(result => {
      this.turnos = result[0];
      this.carriles = result[1];
    }).catch(error => {
      console.log(error);
    });
    
  }

  searchData(){
    this.loadingIndicator = true;
    this.reporteService.getDataReporte(1, { ...this.formBusqueda.value, 'tipoReporte': 3})//reporte carril
    .subscribe(infoBoletos => {
       this.rows = infoBoletos;
       this.calcularTotal();
       this.loadingIndicator = false;
     });
  }

  setPage(event){
    this.loadingIndicator = true;
    let page = event.offset + 1;
    this.reporteService.getDataReporte(page, { ...this.formBusqueda.value, 'tipoReporte': 3})
    .subscribe(infoBoletos => {
       this.rows = infoBoletos;
       this.calcularTotal();
       this.loadingIndicator = false;
     });
  }
   
   calcularTotal(){
    this.rows.data.forEach(dataByCarril => {
      let totalByCarril = 0;
      let cantidad = 0;
      for (let clasificacion in dataByCarril) {
          if (clasificacion !== 'carril') {
            let vehiculo = this.tipoVehiculos.find(vehiculo =>  vehiculo.clasificacion == clasificacion);
            if (vehiculo !== undefined) {
                totalByCarril += parseInt(dataByCarril[clasificacion]) * parseFloat(vehiculo.tarifa);
                cantidad += parseInt(dataByCarril[clasificacion]);
            }
          }
      }
      //set add colums datatable [cantidad y total]
      dataByCarril.cantidad = cantidad;
      dataByCarril.subtotal = totalByCarril;
      this.calcularTotalCobrado();
    });

   }

   calcularTotalCobrado(){
    this.totalCobrado = 0;
    this.rows.data.forEach(dataCarril => {
      console.log(dataCarril.subtotal);
      this.totalCobrado += parseFloat(dataCarril.subtotal);
    });
   }

   //Exportar excel
   exportFileExcel(){
    this.ngxUiLoaderService.start('2');
    let urlExcel:string;
    this.reporteService.descargarArchivo( {...this.formBusqueda.value, 'tipoReporte': 3})
    .then((file:Blob) => {
        let urlDownload = this.reporteService.downloadExcel(file,`reporte_carril_${moment().format('YYYY-MM-DD')}.xlsx`);
        if(urlDownload != ''){
          urlExcel = urlDownload;
          this.ngxUiLoaderService.stop('2');
          return this.toastr.success('Se ha descargado con éxito el archivo Excel', '', { positionClass: 'toast-bottom-right' })  
        }
    })
    .catch(error => {
      console.log(error);
      this.ngxUiLoaderService.stop('2');
      return this.toastr.error(`Por favor intenta de nuevo, ${error}`, 'Error al descargar', { positionClass: 'toast-bottom-right' })
    })
    .finally(() => {
      URL.revokeObjectURL(urlExcel);
    });
   }

}
